/**
 * GoodSender's own favicon `<link>`s — the app-wide fallback (#1099 / US2).
 *
 * ONE constant, imported by both `src/routes/__root.tsx` (every non-blog,
 * non-preview app page) and `src/lib/blog/seo.ts` (a hosted blog page whose
 * publication has no logo), so the two can never disagree about what
 * "GoodSender's icon" looks like. The three entries are exactly what
 * `__root.tsx` inlined before this constant existed.
 */
export const GOODSENDER_ICON_LINKS: ReadonlyArray<Record<string, string>> = [
  { rel: "icon", href: "/favicon.svg", type: "image/svg+xml" },
  { rel: "icon", href: "/favicon.ico", sizes: "48x48 32x32 16x16" },
  { rel: "apple-touch-icon", href: "/apple-touch-icon.png" },
];

/**
 * The `head()` fallback for a `/blog*`/`/preview*` route's `notFound()`
 * branch (no `loaderData`) — every such route falls back to
 * `GOODSENDER_ICON_LINKS` there, because `__root.tsx` omits ITS icon links on
 * every match under those two prefixes regardless of whether the match
 * resolves (#1099 / US2); without this, a 404 on `/blog/*` or `/preview/*`
 * would carry NO icon at all instead of one that still looks like
 * GoodSender.
 *
 * Callers still wrap their ternary in `as never`: the OTHER branch (a
 * `blogPostHead`/`blogIndexHead`/`blogTaxonomyHead`/`blogTermHead` call from
 * `src/lib/blog/seo.ts`) returns `RouteHead`, whose `meta: MetaEntry[]` —
 * carrying the `{"script:ld+json"}` JSON-LD shape — isn't structurally
 * assignable to TanStack's DOM-attribute-typed head shape. That mismatch
 * pre-dates #1099: a bare `{}` else-branch is exempt from TS's "weak type"
 * check, so it went unflagged until the else-branch carried a real property
 * (`links`). See `src/__tests__/preview-head.test.tsx`.
 */
export const NOT_FOUND_HEAD_FALLBACK = { links: [...GOODSENDER_ICON_LINKS] };
